<template>
  <div id="data-view">
    <fullscreen ref="fullscreen" @change="fullscreenChange">

      <div class="data-button">
        <a-button type="button" style="margin: 0 8px" @click="$toTop" icon="swap-left"/>
        <a-button type="button" @click="toggle" :icon="fullscreen? 'fullscreen-exit':'fullscreen'"/>
      </div>
      <div class="data-header">
        QQ社群数据大屏
      </div>
      <div class="data-main">
        <div class="data-content">
          <div class="data-chart">
            <TopLeft/>
          </div>
          <div class="data-chart">
            <TopLeft/>
          </div>
          <div class="data-chart">
            <TopLeft/>
          </div>
        </div>
        <div class="data-content">
          <div>
            <div class="data-chart">
              <TopLeft/>
            </div>
            <div class="data-chart">
              <TopLeft/>
            </div>
          </div>
          <div>
            <div class="data-chart">
              <TopLeft/>
            </div>
          </div>
          <div>
            <div class="data-chart">
              <TopLeft/>
            </div>
            <div class="data-chart">
              <TopLeft/>
            </div>
          </div>
        </div>
      </div>
    </fullscreen>

  </div>
</template>

<script>
  // import TopCenter from '@/components/dataChart/TopCenter'
  // import TopRight from '@/components/dataChart/TopRight'
  import TopLeft from '@/components/dataChart/TopLeft'

  export default {
    components: { TopLeft },
    name: 'DataView',
    data () {
      return {
        fullscreen: false,
      }
    },
    methods: {
      toggle () {
        this.fullscreen = !this.fullscreen
        this.$refs['fullscreen'].toggle() // recommended
        // this.fullscreen = !this.fullscreen // deprecated
      },
      fullscreenChange (fullscreen) {
        this.fullscreen = fullscreen
      },
    },
  }
</script>

<style lang="less" scoped>
  #data-view {
    background-image: url('../../assets/echart_bg.png');
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
  }

  .data-button {
    position: absolute;
    top: 50px;
    left: 10px;
  }

  .data-header {
    font-size: 35px;
    color: white;
    text-align: center;
    margin-top: 35px;
  }

  .data-main {
    color: white;
  }

  .data-content {
    display: flex;
    justify-content: space-around;

    .data-chart {
      max-width: 33%;
      margin: 20px;
    }
  }


</style>
